var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-card"},[(_vm.title)?_c('div',{staticClass:"content-card-header"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"content-card-body",class:{ nopadding: _vm.nopadding }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }